export default __webpack_public_path__ + "static/media/detail_small_9_3.5963f2ed.jpg";